<template>
  <div>
    <div v-if="loading" class="text-center my-3">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <div v-else>
      <b-row v-if="staffName">
        <b-col lg="auto" class="mt-1"
          >Operator: <strong>{{ staffName }}</strong></b-col
        >
        <b-col lg="auto">
          <b-form-select
            v-model="orderSource"
            :options="orderSourceSelect"
            size="sm"
            :state="validateSource"
          ></b-form-select>
        </b-col>
      </b-row>
      <b-row v-if="hasUnpaidLastOrderThisYear">
        <b-col lg="12">
          <b-card>
            <b-card-text>
              <h5 v-if="!currentOs" class="text-center">
                Zamówienie zostało złożone
              </h5>
              <h5 v-else class="text-center">
                Oczekujemy na płatność za zamówienie z dnia
                {{ unpaidOrderData.order.DATA }}
              </h5>
              <order-details
                v-if="unpaidOrderData.order"
                :order="unpaidOrderData.order"
                :products="unpaidOrderData.products"
                :paymentType="unpaidOrderData.paymentType"
                :invoiceData="unpaidOrderData.invoiceData"
                :discountRecommendation="unpaidOrderData.discountRecommendation"
              ></order-details>
            </b-card-text>
            <b-card-text v-if="unpaidOrderData.proformaInvoice">
              <a
                :href="unpaidOrderData.proformaInvoice"
                title="Pobierz Fakturę Proforma"
                >Pobierz Fakturę Proforma
                <i class="fas fa-file-invoice py-0"></i
              ></a>
            </b-card-text>
            <b-card-text
              v-if="unpaidOrderPayu"
              v-html="unpaidOrderPayu"
              class="text-center mb-1"
            ></b-card-text>
            <b-card-text v-if="orderCanBeRemoved" class="text-center mb-1">
              <b-button
                class="my-2 ml-auto mb-2 align-items-center"
                @click="confirmRemove"
                >Usuń to zamówienie i złóż nowe
              </b-button>
            </b-card-text>
            <b-card-text
              v-if="unpaidOrderData.order && currentOs"
              class="text-center"
            >
              <b-button
                class="my-2 ml-auto mb-2 align-items-center"
                @click="proceedToNewOrder"
                >Przejdź dalej do nowego zamówienia
              </b-button>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <div v-else>
        <b-row v-if="!currentOs && changeLicence">
          <b-col lg="12" class="font-italic info-text mt-2">
            <i class="fas fa-exclamation-circle"></i>
            Zmiana numeru NIP możliwa przy jednoczesnym zamówieniu Aktualizacji
            i Opieki Serwisowej na dany rok. Zamów ją i podaj nowe dane w
            kolejnych krokach.
          </b-col>
        </b-row>
        <b-row v-if="!currentOs">
          <b-col lg="12" class="font-italic info-text mt-2 color-red">
            <i class="fas fa-exclamation-circle"></i>
            1. Uwaga! Pamiętaj, aby po zakupie przygotować program SKP<sup
              >®</sup
            >
            do nowego roku (<a
              v-if="isNetworkVersion"
              href="https://www.ksiega-podatkowa.pl/akademia-skp/zmiana-roku-wersja-sieciowa"
              target="_blank"
              >Instrukcja ></a
            ><a
              v-else
              href="https://www.ksiega-podatkowa.pl/akademia-skp/zmiana-roku"
              target="_blank"
              >Instrukcja ></a
            >). <br />
            <i class="fas fa-exclamation-circle"></i>
            2. Dopiero po zmianie roku, możesz wykonać aktualizację (<a
              href="https://www.ksiega-podatkowa.pl/akademia-skp/aktualizacja-programu"
              target="_blank"
              >Instrukcja ></a
            >).
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="12">
            <b-card title="Wybierz produkty" class="title-inline">
              <b-card-text>
                <div
                  class="accordion order-card"
                  role="tablist"
                  id="os"
                  v-show="!formsoftStaff"
                >
                  <b-card no-body class="mb-1 noborder-card">
                    <b-card-header
                      header-tag="header"
                      class="p-1 h6"
                      role="tab"
                    >
                      <span>
                        <img
                          v-if="currentOs || skpAdd"
                          :src="styles.checkbox_old"
                          alt="check"
                          class="pb-1"
                        />
                        <img
                          v-else
                          :src="styles.checkbox_new"
                          @click="warningOsMandatory"
                          alt="check"
                          class="pb-1"
                        />
                      </span>
                      <span>
                        <span class="os-title font-weight-bold"
                          >Opieka Serwisowa {{ year }} wraz ze stałą,
                          automatyczną aktualizacją programu
                        </span>
                      </span>
                      <span v-b-toggle.service>
                        <span class="when-closed px-2">
                          <i class="fas fa-chevron-down"></i
                        ></span>
                        <span class="when-open px-2"
                          ><i class="fas fa-chevron-up when-open"></i
                        ></span>
                      </span>
                      <span v-if="!currentOs" class="ml-2">
                        <span v-if="osOldPrice" class="small px-2">
                          <span class="text-danger line-through"
                            >{{ commaFormat(osOldPrice) }} zł</span
                          >
                        </span>
                        {{ commaFormat(osPrice) }} zł

                        <span v-if="osOldPrice" class="small px-2">
                          (Najniższa cena z 30 dni przed obniżką:
                          {{ commaFormat(osOldPrice) }} zł)
                        </span>
                      </span>

                      <span class="payu-info-credit">
                        Tutaj kupisz <strong>NA RATY PayU</strong>!
                        <a
                          href="https://www.ksiega-podatkowa.pl/akademia-skp/zamowienie-programu-raty-payu?ref=zamówienie_wybierz_produkty_MK"
                          target="_blank"
                          >Więcej ></a
                        >
                      </span>
                      <br />
                      <div
                        v-if="
                          currentDiscountIds.includes(607) &&
                          program === 'sam' &&
                          !currentOs
                        "
                        class="promo-box g-color-black g-font-normal"
                      >
                        <div v-if="betweenDate('2022-09-22', '2022-09-26')">
                          % PROMOCJA: Opieka Serwisowa z
                          <strong class="color-red">rabatem 50%</strong> oraz
                          <strong class="color-red">0 zł za przejście</strong>
                          na program SKP<sup>®</sup> ! Przejdź do podsumowania i
                          wyślij zamówienie do <strong>30.09.2022 r.</strong>
                          <br /><strong class="color-red">Ważne:</strong> Usługa
                          przejścia na SKP<sup>®</sup> uruchomiona będzie po
                          20.09.2022r.
                          <a
                            href="https://www.samozatrudnienie.pl/przewodnik-przedsiebiorcy/sam-zmiana-na-skp"
                            target="_blank"
                            >Co zyskasz przechodząc na SKP<sup>®</sup></a
                          >
                        </div>
                        <div
                          v-else-if="betweenDate('2022-09-27', '2022-09-30')"
                        >
                          % PROMOCJA: Opieka Serwisowa z
                          <strong class="color-red">RABATEM 50%</strong> oraz
                          <strong class="color-red">0 zł za przejście</strong>
                          na program SKP<sup>®</sup> ! Przejdź do podsumowania i
                          wyślij zamówienie do <strong>30.09.2022 r.</strong
                          ><br />
                          <strong class="color-red">Ważne:</strong>: Usługa
                          przejścia na SKP<sup>®</sup> została uruchomiona
                          27.09.2022r.
                          <a
                            href="https://www.samozatrudnienie.pl/przewodnik-przedsiebiorcy/sam-zmiana-na-skp"
                            target="_blank"
                            >Co zyskasz przechodząc na SKP<sup>®</sup></a
                          >
                        </div>
                        <div
                          v-else-if="betweenDate('2022-10-01', '2022-10-09')"
                        >
                          Zamów Opiekę Serwisową na 2022 i zyskaj
                          <strong class="color-red">0 zł za przejście</strong>
                          na program SKP<sup>®</sup> ! Przejdź do podsumowania i
                          wyślij zamówienie.<br />
                          <strong class="color-red">Ważne:</strong> Usługa
                          przejścia na SKP<sup>®</sup>
                          została uruchomiona 27.09.2022r.
                          <a
                            href="https://www.samozatrudnienie.pl/przewodnik-przedsiebiorcy/sam-zmiana-na-skp"
                            target="_blank"
                            >Co zyskasz przechodząc na SKP<sup>®</sup></a
                          >
                        </div>
                        <div
                          v-else-if="betweenDate('2022-10-10', '2022-11-30')"
                        >
                          % PROMOCJA: Opieka Serwisowa z
                          <strong class="color-red">RABATEM 60%</strong> oraz
                          <strong class="color-red">0 zł za przejście</strong>
                          na program SKP<sup>®</sup> ! Przejdź do podsumowania i
                          wyślij zamówienie do <strong>30.11.2022 r.</strong
                          ><br />
                          Ważne: Usługa przejścia na SKP<sup>®</sup> została
                          uruchomiona 27.09.2022r.
                          <a
                            href="https://www.samozatrudnienie.pl/przewodnik-przedsiebiorcy/sam-zmiana-na-skp"
                            target="_blank"
                            >Co zyskasz przechodząc na SKP<sup>®</sup></a
                          >
                        </div>
                      </div>

                      <span v-if="client.L === 2" class="promo-box">
                        BONUS! Brak dodatkowej opłaty 15% za roczną przerwę w
                        kontynuacji Opieki Serwisowej.
                      </span>

                      <span v-if="isDiscount656_657 && false" class="promo-box">
                        <i class="fas fa-percent"></i> PROMOCJA: Zamów Opiekę
                        Serwisową na 2024 i
                        <span style="color: red">zyskaj ZA DARMO</span>: opiekę
                        na cały 2025 + usługę online SKP24 Connect
                        <span v-if="isAccountant">pakiet Extra</span> do końca
                        2024. Oferta ważna do 11.10.2024 r.
                      </span>

                      <span
                        v-if="
                          osDiscount &&
                          [636].includes(osDiscount.id) &&
                          !currentOs
                        "
                        class="promo-box"
                      >
                        Ważne: Z dniem 01.01.2023r zaprzestaliśmy wsparcia
                        programu SAMozatrudnienie. Wybierając ten produkt,
                        kupujesz Opiekę Serwisową 2023 do programu SKP<sup
                          >®</sup
                        >
                        z rabatem 50%. Przejdź do podsumowania, wyślij
                        zamówienie, a następnie uruchom posiadaną wersję SAM<sup
                          >®</sup
                        >
                        i przejdź na SKP<sup>®</sup>. Promocja ważna do
                        {{ formatSimpleWithDots(osDiscount.dateFinish) }} r.
                      </span>

                      <span v-else-if="discount25Anniversary" class="promo-box">
                        50% RABAT za 25 lat korzystania z SKP<sup>®</sup>
                      </span>

                      <div
                        v-else-if="
                          osDiscount && osDiscount.id === 641 && !currentOs
                        "
                        class="promo-box"
                      >
                        <i class="fas fa-percent"></i> PROMOCJA: Opieka
                        Serwisowa z
                        <span style="color: red">rabatem 50 zł</span> ! Aby
                        skorzystać, przejdź do podsumowania i wyślij zamówienie.
                        Oferta ważna do
                        {{ formatSimpleWithDots(osDiscount.dateFinish) }}
                      </div>

                      <div
                        v-else-if="
                          osDiscount &&
                          (osDiscount.id === 608 || osDiscount.id === 613) &&
                          !currentOs
                        "
                        class="promo-box"
                      >
                        <i class="fas fa-percent"></i> PROMOCJA: Opieka
                        serwisowa na rok 2023 za darmo! Aby skorzystać, przejdź
                        do podsumowania i wyślij zamówienie.
                      </div>

                      <div
                        v-else-if="
                          osDiscount &&
                          !currentOs &&
                          (program === 'skp' || program === 'sam')
                        "
                        class="promo-box"
                      >
                        <i class="fas fa-percent"></i> PROMOCJA: Opieka
                        Serwisowa
                        <span
                          v-if="
                            program === 'sam' &&
                            new Date().getFullYear() === 2023
                          "
                          >na SKP<sup>®</sup> w 2023 r.</span
                        >
                        z
                        <span style="color: red"
                          >rabatem {{ osDiscount.percent }}%</span
                        >
                        <strong v-if="currentDiscountIds.includes(625)"
                          >+ moduły i dodatki</strong
                        >
                        ! Aby skorzystać, przejdź do podsumowania i wyślij
                        zamówienie. Oferta ważna do
                        {{ formatSimpleWithDots(osDiscount.dateFinish) }} r.
                      </div>
                    </b-card-header>
                    <b-collapse id="service" accordion="os" role="tabpanel">
                      <b-card-body>
                        <b-card-text>
                          W ramach Opieki Serwisowej otrzymujesz m.in:
                          <ul>
                            <li>
                              bieżącą aktualizację programu, dostosowaną do
                              zmian prawnych i funkcjonalnych,
                            </li>
                            <li>pomoc naszych konsultantów,</li>
                            <li>serwis danych na wypadek uszkodzenia</li>
                          </ul>
                        </b-card-text>
                        <b-card-text>
                          Przeczytaj o wszystkich
                          <b-link
                            :href="osLink"
                            class="font-italic"
                            target="_blank"
                            >korzyściach Opieki Serwisowej >
                          </b-link>
                        </b-card-text>
                        <b-card-text>
                          Dostępne masz wszystkie główne wersje programu,
                          oznaczone jako 23.0, 23.1
                          <b-link
                            :href="osVersionsLink"
                            class="font-italic"
                            target="_blank"
                            >Dowiedz się więcej >
                          </b-link>
                        </b-card-text>
                      </b-card-body>
                    </b-collapse>
                  </b-card>
                </div>

                <div
                  v-if="
                    !isLimitedVersion &&
                    declarationsSeason &&
                    !skpAdd &&
                    annualDeclarations
                  "
                  class="accordion order-card"
                  role="tablist"
                  id="annualDeclarations"
                >
                  <b-card no-body class="mb-1 noborder-card">
                    <b-card-header
                      header-tag="header"
                      class="p-1 font-weight-bold h6"
                      role="tab"
                    >
                      <order-checkbox
                        v-on:addproduct="addProduct"
                        :wasChecked="annualDeclAlreadyChecked"
                        :isChecked="annualDecl"
                        :product="annualDeclarations"
                        :styles="styles"
                        :text="annualDeclText"
                      >
                      </order-checkbox>
                      <span v-b-toggle.declarationsDesc>
                        <span class="when-closed px-2">
                          <i class="fas fa-chevron-down"></i
                        ></span>
                        <span class="when-open px-2"
                          ><i class="fas fa-chevron-up when-open"></i
                        ></span>
                      </span>
                      <span v-if="!annualDeclAlreadyChecked" class="ml-2">
                        <span
                          v-if="annualDeclarations.OLD_NETTO"
                          data-v-8fe7a89a=""
                          class="text-danger line-through small px-2"
                        >
                          {{ commaFormat(annualDeclarations.OLD_NETTO) }} zł
                        </span>
                        <span else>
                          {{ commaFormat(annualDeclarations.NETTO) }} zł
                        </span>
                      </span>
                    </b-card-header>
                    <b-card-body>
                      <b-collapse
                        id="declarationsDesc"
                        accordion="annualDeclarations"
                        role="tabpanel"
                      >
                        <b-card-text>
                          <div v-if="program === 'skp'" class="mt-1">
                            Dostępne są deklaracje: PIT-36, -36S, -36L, -36LS,
                            -37 (gdy posiadasz moduł Płace i ZUS), -38, -39 wraz
                            z załącznikami oraz pełną listą numerów KRS.
                            Pamiętaj, że wysyłka e-Deklaracji będzie możliwa po
                            opublikowaniu ministerialnych e-Deklaracji.
                          </div>
                          <div v-else class="mt-1">
                            Dostępne są deklaracje: PIT-36, -36S, -36L, -36LS,
                            -38, -39 wraz z załącznikami oraz pełną listą
                            numerów KRS. Pamiętaj, że wysyłka e-Deklaracji
                            będzie możliwa po opublikowaniu ministerialnych
                            e-Deklaracji.
                          </div>
                          <div class="mt-1 font-italic color-red">
                            Uwaga! Deklaracje roczne dotyczą roku ubiegłego i
                            dostępne są w programie SKP {{ year - 1 }}.
                          </div>
                        </b-card-text>
                      </b-collapse>
                    </b-card-body>
                  </b-card>
                </div>

                <course-product
                  v-if="
                    !currentOs &&
                    program === 'skp' &&
                    !isLimitedVersion &&
                    typeof productsPrices[0] !== 'undefined'
                  "
                  v-on:addproduct="addProduct"
                  :client="client"
                  :isChecked="annualDecl"
                  :products="productsPrices"
                  :styles="styles"
                  :text="annualDeclText"
                  :year="year"
                  :program="program"
                ></course-product>

                <div
                  v-if="
                    program === 'skp' && accountantVersions && !isLimitedVersion
                  "
                  class="accordion order-card"
                  role="tablist"
                  id="accountantVersion"
                >
                  <product-select-row
                    :styles="styles"
                    cssType="main-product"
                    :products="accountantVersionsFiltered"
                    :wasCheckedOption="clientAccountantOption"
                    :isCheckedOption="selectedAccountantOption"
                    :disabled="clientAccountantOption != null"
                    type="B"
                    bold="true"
                    accordionId="skp-products"
                    v-on:addproduct="addProduct"
                  ></product-select-row>
                </div>
                <div v-if="false" class="order-card">
                  <b-card no-body class="mb-1 noborder-card">
                    <b-card-header
                      header-tag="header"
                      class="p-1 font-weight-bold h6"
                      role="tab"
                    >
                      <span class="os-title"
                        >Zmiana programu na SKP<sup>®</sup>
                      </span>
                      <span v-b-toggle.changeToSkpAccordion>
                        <span class="when-closed px-2">
                          <i class="fas fa-chevron-down"></i
                        ></span>
                        <span class="when-open px-2"
                          ><i class="fas fa-chevron-up when-open"></i
                        ></span>
                      </span>
                    </b-card-header>
                    <b-card-body class="pl-0">
                      <b-collapse
                        id="changeToSkpAccordion"
                        accordion="changeToSkpAccordion"
                        role="tabpanel"
                      >
                        <b-card-text>
                          <div class="mt-1 mb-3">
                            Decydując się na zmianę obecnego programu na SKP<sup
                              >®</sup
                            >
                            zyskasz rozbudowany program do małej księgowości. Do
                            wyboru masz 2 wersje: SKP<sup>®</sup> Start dla Firm
                            i SKP<sup>®</sup> Start dla Biur. <br />
                            <p class="text-info">
                              <strong>Uwaga!</strong> Zaznaczenie tego
                              rozszerzenia spowoduje zmianę posiadanego programu
                              i tym samym konieczna będzie dopłata różnicy do
                              już posiadanych modułów i dodatków. Zostaną one
                              automatycznie zaznaczone i zobaczysz kwotę
                              dopłaty. Możesz także dokupić zupełnie nowe, z
                              których nie korzystałeś do tej pory, bądź które są
                              elementem nowej oferty.
                            </p>
                          </div>
                        </b-card-text>
                      </b-collapse>
                      <b-card-text>
                        <b-card
                          v-for="(product, index) in changeToSkpProducts"
                          :key="index"
                          no-body
                          class="mb-1 no-border-bottom"
                        >
                          <product-row
                            :styles="styles"
                            :product="product"
                            :productData="product"
                            :isAccountant="isAccountant"
                            :accountantAdd="accountantAdded"
                            :skpAdd="skpAdd"
                            :unpaidOrder="unpaidOrder"
                            type="skp"
                            v-on:addproduct="addProduct"
                          ></product-row>
                        </b-card>
                        <product-select-row
                          v-if="false"
                          :styles="styles"
                          :products="accountantVersions"
                          :wasCheckedOption="clientAccountantOption"
                          :isCheckedOption="selectedAccountantOption"
                          :disabled="clientAccountantOption != null"
                          type="B"
                          accordionId="skp-products"
                          v-on:addproduct="addProduct"
                        ></product-select-row>
                      </b-card-text>
                    </b-card-body>
                  </b-card>
                </div>
                <b-row>
                  <b-col>
                    <div
                      v-if="
                        discountsToCheckConditions.length > 0 &&
                        discountsDescriptions.length > 0
                      "
                      class="promo-box"
                    >
                      <i class="fas fa-percent"></i> PROMOCJA:
                      <span v-html="discountsDescriptions"></span>
                    </div>
                  </b-col>
                </b-row>
                <b-row v-if="productsPrices.length > 0">
                  <b-col md="6" v-show="moduleElementShow">
                    <p
                      class="
                        font-weight-bold
                        mt-1
                        mb-2
                        h6
                        pl-1
                        steps-adds-modules
                      "
                    >
                      <span
                        v-if="
                          moduleElementShow &&
                          accountantAdd &&
                          hasZUSOption != null &&
                          lastFirstModuleUnchecked !== -1 &&
                          (program === 'skp' || skpAdd)
                        "
                      >
                        Dopłać do obecnie posiadanych modułów:
                      </span>
                      <span
                        v-else-if="
                          moduleElementShow &&
                          isAccountant &&
                          !accountantAdd &&
                          hasZUSOption != null &&
                          lastFirstModuleUnchecked !== -1 &&
                          (program === 'skp' || skpAdd) &&
                          !(
                            clientZUSOption === 'P3' || clientZUSOption === 'B3'
                          )
                        "
                      >
                        Dopłać do obecnie posiadanych modułów:
                      </span>
                      <span
                        v-else-if="
                          hasZUSOption != null &&
                          lastFirstModuleUnchecked === -1 &&
                          (program === 'skp' || skpAdd)
                        "
                      >
                        Rozbuduj
                        <span v-if="!skpAdd && program === 'sam'">SAM</span>
                        <span v-else>SKP</span><sup>®</sup> o dodatkowe moduły:
                      </span>
                    </p>

                    <p
                      v-if="
                        accountantAdded && !isAccountant && program === 'skp'
                      "
                      class="text-info"
                    >
                      Uwaga! Przy przejściu z SKP<sup>®</sup> Firma na SKP<sup
                        >®</sup
                      >
                      Biuro konieczna jest dopłata do posiadanych modułów.
                      Zaznacz te, które chcesz zachować i dopłacić różnicę.
                    </p>
                    <div
                      class="accordion order-card"
                      role="tablist"
                      id="modules-list"
                    >
                      <product-select-row
                        v-if="
                          hasZUSOption != null &&
                          lastFirstModuleUnchecked === -1 &&
                          (program === 'skp' || skpAdd)
                        "
                        :styles="styles"
                        :products="paymentZUSVersions"
                        :wasCheckedOption="clientZUSOption"
                        :isCheckedOption="selectedZUSOption"
                        :disabled="clientZUSOption != null"
                        :accountantAdd="accountantAdded"
                        :isAccountant="isAccountant"
                        type="P"
                        accordionId="zus-products"
                        v-on:addproduct="addProduct"
                      ></product-select-row>
                      <p
                        v-if="
                          accountantAdd &&
                          hasZUSOption != null &&
                          lastFirstModuleUnchecked === -1 &&
                          (program === 'skp' || skpAdd)
                        "
                        class="
                          font-weight-bold
                          mt-1
                          mb-2
                          h6
                          pl-1
                          steps-adds-modules
                        "
                      >
                        Rozbuduj
                        <span v-if="!skpAdd && program === 'sam'">SAM</span
                        ><span v-else>SKP</span><sup>®</sup> o dodatkowe moduły:
                      </p>

                      <div
                        v-for="(module, index, key) in modules"
                        :key="index.key"
                      >
                        <product-select-row
                          v-if="
                            hasZUSOption != null &&
                            module.firstUnchecked === key &&
                            (program === 'skp' || skpAdd)
                          "
                          :styles="styles"
                          :products="paymentZUSVersions"
                          :wasCheckedOption="clientZUSOption"
                          :isCheckedOption="selectedZUSOption"
                          :disabled="clientZUSOption != null"
                          :accountantAdd="accountantAdded"
                          :isAccountant="isAccountant"
                          type="P"
                          accordionId="zus-products"
                          v-on:addproduct="addProduct"
                        ></product-select-row>
                        <p
                          v-if="
                            accountantAdd &&
                            module.firstUnchecked === key &&
                            (program === 'skp' || skpAdd)
                          "
                          class="
                            font-weight-bold
                            mt-1
                            mb-2
                            h6
                            pl-1
                            steps-adds-modules
                          "
                        >
                          Rozbuduj
                          <span v-if="!skpAdd && program === 'sam'">SAM</span
                          ><span v-else>SKP</span><sup>®</sup> o dodatkowe
                          moduły:
                        </p>
                        <p
                          v-if="
                            !accountantAdd &&
                            hasZUSOption != null &&
                            module.firstUnchecked === key &&
                            (program === 'skp' || skpAdd)
                          "
                          class="
                            font-weight-bold
                            mt-1
                            mb-2
                            h6
                            pl-1
                            steps-adds-modules
                          "
                        >
                          Rozbuduj
                          <span v-if="!skpAdd && program === 'sam'">SAM</span
                          ><span v-else>SKP</span><sup>®</sup> o dodatkowe
                          moduły:
                        </p>
                        <product-row
                          :styles="styles"
                          :product="module"
                          :productData="getProductData(module)"
                          :isAccountant="isAccountant"
                          :hideWhenOwned="true"
                          :accountantAdd="accountantAdded"
                          :skpAdd="skpAdd"
                          :unpaidOrder="unpaidOrder"
                          accordion-id="modules-list"
                          type="module"
                          v-on:addproduct="addProduct"
                          v-on:minimadded="minimAddChanged"
                          v-on:showProductsElements="showProductsElements"
                        ></product-row>
                      </div>
                      <product-select-row
                        v-if="
                          ((!isAccountant &&
                            hasZUSOption != null &&
                            lastFirstModuleUnchecked === -1) ||
                            hasZUSOption == null ||
                            (hasZUSOption == null &&
                              lastFirstModuleUnchecked >= 0 &&
                              lastFirstModuleUnchecked < 99) ||
                            (hasZUSOption != null &&
                              hasZUSOption !== 'P3' &&
                              lastFirstModuleUnchecked === 99)) &&
                          (program === 'skp' || skpAdd)
                        "
                        :styles="styles"
                        :products="paymentZUSVersions"
                        :wasCheckedOption="clientZUSOption"
                        :isCheckedOption="selectedZUSOption"
                        :disabled="clientZUSOption != null"
                        :accountantAdd="accountantAdded"
                        :isAccountant="isAccountant"
                        type="P"
                        accordionId="zus-products"
                        v-on:addproduct="addProduct"
                      ></product-select-row>
                    </div>
                  </b-col>
                  <b-col
                    md="6"
                    v-if="adds && Object.keys(adds).length > 0"
                    v-show="addElementShow"
                  >
                    <div
                      class="accordion order-card"
                      role="tablist"
                      id="adds-list"
                    >
                      <p
                        class="font-weight-bold mt-1 mb-2 h6 pl-1"
                        v-if="!accountantAdd && (program === 'skp' || skpAdd)"
                      >
                        <span class="steps-adds-modules">
                          Uzupełnij program o pomocne dodatki:
                        </span>
                      </p>
                      <p
                        class="font-weight-bold mt-1 mb-2 h6 pl-1"
                        v-if="
                          accountantAdd &&
                          lastFirstAddsUnchecked === -1 &&
                          (program === 'skp' || skpAdd)
                        "
                      >
                        <span class="steps-adds-modules">
                          Uzupełnij program o pomocne dodatki:
                        </span>
                      </p>
                      <div v-for="(add, index, key) in adds" :key="index">
                        <p
                          class="font-weight-bold mt-1 mb-2 h6 pl-1"
                          v-if="
                            accountantAdd &&
                            wasAccountant &&
                            client.MDS !== null &&
                            client.MDS !== '' &&
                            client.MDS.split('').includes('M') &&
                            add.firstUnchecked === false &&
                            (program === 'skp' || skpAdd)
                          "
                        >
                          <span class="steps-adds-modules">
                            Dopłać do obecnie posiadanych dodatków:
                          </span>
                        </p>
                        <p
                          class="font-weight-bold mt-1 mb-2 h6 pl-1"
                          v-else-if="
                            accountantAdd &&
                            !wasAccountant &&
                            client.MDS !== null &&
                            client.MDS !== '' &&
                            add.firstUnchecked === false &&
                            (program === 'skp' || skpAdd)
                          "
                        >
                          <span class="steps-adds-modules">
                            Dopłać do obecnie posiadanych dodatków:
                          </span>
                        </p>
                        <p
                          class="font-weight-bold mt-1 mb-2 h6 pl-1"
                          v-else-if="
                            accountantAdd &&
                            add.firstUnchecked === key &&
                            (program === 'skp' || skpAdd)
                          "
                        >
                          <span class="steps-adds-modules">
                            Uzupełnij program o pomocne dodatki:
                          </span>
                        </p>
                        <product-row
                          :styles="styles"
                          :product="add"
                          :productData="getProductData(add)"
                          :hideWhenOwned="true"
                          :isAccountant="isAccountant"
                          :accountantAdd="accountantAdded"
                          :skpAdd="skpAdd"
                          :unpaidOrder="unpaidOrder"
                          accordion-id="adds-list"
                          type="add"
                          v-on:addproduct="addProduct"
                          v-on:showProductsElements="showProductsElements"
                        ></product-row>
                      </div>
                    </div>
                  </b-col>
                </b-row>

                <b-row v-if="!betweenDate('2023-03-06', '2023-03-22')">
                  <b-col>
                    <code-discount
                      v-on:reloadProducts="reloadProducts"
                    ></code-discount>
                  </b-col>
                </b-row>

                <b-row>
                  <span class="font-weight-bold ml-auto px-4 h6"
                    >RAZEM NETTO: {{ commaFormat(totalProducts) }} zł
                  </span>
                </b-row>

                <b-row>
                  <span class="small ml-auto px-4 h6 mt-2"
                    >W podsumowaniu zamówienia do powyższych cen zostanie
                    doliczony podatek VAT 23%</span
                  >
                </b-row>
                <b-row v-if="errors.length"
                  ><p></p>
                  <ul>
                    <li
                      v-for="error in errors"
                      :key="error"
                      class="text-danger"
                    >
                      {{ error }}
                    </li>
                  </ul>
                </b-row>
              </b-card-text>
            </b-card>
            <b-card
              v-if="notRegistered"
              title="Opieka Serwisowa"
              class="title-inline"
            >
              <b-card-text> Zarejestruj program</b-card-text>
            </b-card>
          </b-col>
        </b-row>

        <b-row v-if="!notRegistered">
          <p class="bot-link" @click="runChat">
            <strong>Potrzebujesz szybkiej pomocy?<br /></strong>
            Zapytaj Wirtualnego Asystenta SKP<sup>®</sup> >
          </p>
          <b-button
            v-if="currentStep !== 1"
            variant="secondary"
            class="mx-3 mb-2 btn ml-auto btn-secondary btn-color"
            @click="backStep"
            >Wstecz
          </b-button>
          <b-button
            variant="success"
            :class="{ 'ml-auto': currentStep === 1 }"
            class="mx-3 mb-2 btn-accept-color"
            @click="forwardStep"
            >Dalej
          </b-button>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import ProductRow from './ProductRow';
import ProductSelectRow from './ProductSelectRow';
import OrderCheckbox from './OrderCheckbox';
import OrderDetails from '../OrderDetails';
import CourseProduct from './CustomProducts/CourseProduct';
import { mapGetters } from 'vuex';
import DateHelper from '../../../helper/dateHelper';
import moment from 'moment';
import {
  modules,
  m_sam,
  m_skp_F,
  m_skp_B,
  m_all,
  m_skp_O,
} from '../../config/modules';
import { adds, a_sam, a_skp_B, a_skp_F, a_all } from '../../config/adds';
import {
  skp_plans_F,
  skp_plans_B,
  sam_plans,
  skp_plans,
} from '../../config/cloudPlans';
import NumbersHelper from '../../../helper/numbersHelper';
import Cookies from '../../../helper/cookiesHelper';
import CodeDiscount from './CodeDiscount';

export default {
  name: 'OrderProducts',
  props: {
    styles: {},
    changeLicence: { required: false },
    isAccountant: { type: Boolean, default: false },
    accountantAdd: { required: true, type: Boolean },
    skpAdd: { default: null },
    skpCompanyAdd: { type: Boolean, default: false },
    skpAccountantAdd: { type: Boolean, default: false },
    isDiscount656_657: { type: Boolean, default: false },
  },
  data() {
    return {
      year: process.env.MIX_AKTU_YEAR,
      osOldPrice: null,
      osPrice: null,
      osDiscount: null,
      errors: [],
      productsPrices: {},
      orderSourceSelect: [
        { value: 'te', text: 'Telefonicznie' },
        { value: 'os', text: 'Osobiście' },
        { value: 'ma', text: 'Mailem' },
        { value: 'in', text: 'Inne' },
      ],
      accountantVersions: null,
      paymentZUSVersionsF: {},
      paymentZUSVersionsB: {},
      minimAdd: false,
      changeToSkpProducts: {},
      currentDiscounts: {},
      validated: false,
      unpaidOrderData: null,
      unpaidOrder: null,
      unpaidOrderPayu: '',
      loading: false,
      discountErrorMsg: '',
      discountNotUsed: null,
      seasonalDiscountUsed: null,
      currentOsOrder: null,
      twoLastYearsOsOrders: false,
      moduleElementShow: false,
      addElementShow: false,
    };
  },
  components: {
    CodeDiscount,
    ProductRow,
    ProductSelectRow,
    OrderCheckbox,
    OrderDetails,
    CourseProduct,
  },
  computed: {
    ...mapGetters({
      program: 'getProgram',
      currentOs: 'auth/currentOs',
      client: 'auth/client',
      totalProducts: 'order/totalProducts',
      getOs: 'order/os',
      licence: 'auth/userLicence',
      isInCart: 'order/isInCartProducts',
      cartProducts: 'order/getCartProducts',
      source: 'order/orderSource',
      currentStep: 'order/currentStep',
      orderQuery: 'auth/getOrderQuery',
    }),
    formsoftStaff() {
      return (
        localStorage.getItem('staffName') === 'formsoft' &&
        localStorage.getItem('staffId') === '0'
      );
    },
    currentDiscountIds() {
      return Object.values(this.currentDiscounts).map((discount) => {
        return discount.id;
      });
    },
    discount25Anniversary() {
      return (
        this.program == 'skp' &&
        !this.currentOs &&
        this.client.K == '1' &&
        this.client.M != '1' &&
        [1, 2, 3].includes(this.client.L) &&
        [25].includes(
          moment().format('YYYY') - moment(this.client.SPR).format('YYYY')
        )
      );
    },
    staffName() {
      return localStorage.getItem('staffName');
    },
    hasUnpaidLastOrderThisYear() {
      return (
        this.unpaidOrderData &&
        this.unpaidOrderData.order &&
        this.unpaidOrderData.order.STATUS_PL !== 99
      );
    },
    lastFirstModuleUnchecked() {
      let last,
        modules = this.modules != null ? Object.entries(this.modules) : [];
      if (typeof this.modules !== 'undefined') {
        last = modules[Object.keys(this.modules).length - 1][1];
      }
      return last.firstUnchecked;
    },
    lastFirstAddsUnchecked() {
      let last,
        adds = this.adds != null ? Object.entries(this.adds) : [];
      if (typeof this.adds !== 'undefined') {
        last = adds[Object.keys(this.adds).length - 1][1];
      }
      return last.firstUnchecked;
    },
    orderCanBeRemoved() {
      return (
        this.unpaidOrderData.order.PL === null ||
        (this.unpaidOrderData.order.PL &&
          !this.unpaidOrderData.order.PL.includes('POBRANIE')) ||
        (this.unpaidOrderData.order.PL.includes('POBRANIE') && this.staffName)
      );
    },
    notRegistered() {
      return this.client.SPR === '1899-12-30' || this.client.SPR === null;
    },
    wasAccountant() {
      return (
        this.client.MDS !== null &&
        this.client.MDS !== '' &&
        this.client.MDS.split('').includes('B')
      );
    },
    isLimitedVersion() {
      return (
        this.client.MDS !== null &&
        this.client.MDS !== '' &&
        this.client.MDS.split('').includes('O')
      );
    },
    isNetworkVersion() {
      if (this.client && this.client.MDS !== null) {
        return (
          this.client.MDS !== null &&
          this.client.MDS !== '' &&
          this.client.MDS.split('').includes('S')
        );
      }
      return false;
    },
    accountantAdded() {
      return this.accountantAdd;
    },
    accountantVersionsFiltered() {
      let currentVersion = this.clientAccountantOption
        ? this.clientAccountantOption.slice(
            this.clientAccountantOption.length - 1
          )
        : null;

      if (
        currentVersion &&
        Number(currentVersion) === 2 &&
        (!this.accountantAdded || (this.accountantAdded && this.isAccountant))
      ) {
        return this.accountantVersions.filter((item) => item.key !== 'B1');
      }

      return this.accountantVersions;
    },
    clientAccountantOption() {
      return this.isAccountant &&
        this.client.MDS !== null &&
        this.client.MDS !== '' &&
        this.client.MDS.split('').includes('B')
        ? 'B' + this.client.B_level
        : null;
    },
    selectedAccountantOption() {
      //maybe to change
      if (this.accountantAdded) {
        let product = this.cartProducts.filter((row) =>
          row.label.includes('SKP® BIURO START')
        );
        return product.length > 0 ? product[0] : false;
      }
      return false;
    },
    paymentZUSVersions() {
      let currentVersion = this.clientZUSOption
        ? this.clientZUSOption.slice(this.clientZUSOption.length - 1)
        : null;

      if (
        currentVersion &&
        Number(currentVersion) === 2 &&
        (!this.accountantAdded || (this.isAccountant && this.accountantAdded))
      ) {
        let options = this.isAccountant
          ? this.paymentZUSVersionsB
          : this.paymentZUSVersionsF;

        return options.filter((item) => item.key !== 'P1');
      }

      return this.isAccountant
        ? this.paymentZUSVersionsB
        : this.paymentZUSVersionsF;
    },
    clientZUSOption() {
      if (
        this.client.MDS !== null &&
        this.client.MDS !== '' &&
        this.client.MDS.split('').includes('P') &&
        (!this.accountantAdded || this.client.MDS.split('').includes('B'))
      ) {
        return 'P' + this.client.P_level;
      }
      return null;
    },
    hasZUSOption() {
      if (
        this.client.MDS !== null &&
        this.client.MDS !== '' &&
        this.client.MDS.split('').includes('P')
      ) {
        return 'P' + this.client.P_level;
      }
      return null;
    },
    selectedZUSOption() {
      if (this.isAccountant) {
        let product = this.cartProducts.find(
          (item) =>
            item.label.includes('Płace i ZUS') &&
            item.UWAGI === 'M_SKP_MODULY_BIURO'
        );
        return product !== undefined ? product : null;
      }

      let product = this.cartProducts.find(
        (item) =>
          item.label.includes('Płace i ZUS') &&
          item.UWAGI === 'M_SKP_MODULY_FIRMA'
      );

      return product !== undefined ? product : null;
    },
    os: {
      get() {
        return this.getOs;
      },
      set(value) {
        if (value === true && !this.currentOs) {
          this.$store.commit('order/setOs', true);
        } else {
          this.$store.commit('order/setOs', false);
        }
      },
    },
    aktuEmail: {
      get() {
        return this.isInCart(this.aktu);
      },
      set(value) {
        if (value === true) {
          this.$store.commit('order/addProduct', this.aktu);
        } else {
          this.$store.commit('order/removeProduct', this.aktu);
        }
      },
    },
    annualDeclarations() {
      if (Object.keys(this.productsPrices).length > 0) {
        if (this.program === 'skp' && !this.wasAccountant) {
          return this.productsPrices.filter((item) => item.ID === 52)[0];
        } else if (this.program === 'skp' && this.wasAccountant) {
          return this.productsPrices.filter((item) => item.ID === 22)[0];
        }
        if (
          this.program === 'sam' &&
          !this.skpAdd &&
          this.client.AKT_22 != null
        ) {
          return this.productsPrices.filter((item) => item.ID === 53)[0];
        }
      }

      return null;
    },
    annualDecl() {
      return this.isInCart(this.annualDeclarations);
    },
    annualDeclText() {
      return 'Deklaracje roczne PIT za rok ' + (this.year - 1).toString();
    },
    orderSource: {
      get() {
        return this.source;
      },
      set(value) {
        if (value) {
          this.$store.commit('order/setOrderSource', value);
        }
      },
    },
    aktuEmailAlreadyChecked() {
      let year = this.year.substring(2);

      return this.client['AUTO_' + year] === 3;
    },
    annualDeclAlreadyChecked() {
      let lastYear = (this.year.slice(this.year.length - 1) - 1).toString();
      return (
        this.client.DOD !== null &&
        this.client.DOD !== '' &&
        this.client.DOD.split('').includes(lastYear)
      );
    },
    modules() {
      let mod;
      if (this.program === 'skp' && this.isLimitedVersion) {
        mod = m_skp_O.reduce(
          (obj, key) => ({ ...obj, [key]: modules[key] }),
          {}
        );
      } else if (
        (this.program === 'skp' && this.isAccountant) ||
        this.skpAccountantAdd
      ) {
        mod = m_skp_B.reduce(
          (obj, key) => ({ ...obj, [key]: modules[key] }),
          {}
        );
      } else if (
        (this.program === 'skp' && !this.isAccountant) ||
        this.skpCompanyAdd
      ) {
        mod = m_skp_F.reduce(
          (obj, key) => ({ ...obj, [key]: modules[key] }),
          {}
        );
      } else {
        mod = m_sam.reduce((obj, key) => ({ ...obj, [key]: modules[key] }), {});
      }
      mod = mod != null ? Object.entries(mod) : [];
      mod.sort((row) => (this.isAlreadyChecked(row[0]) ? -1 : 1));

      // sort product list to display it in two separate category when not-accountant checked "B"
      let firstUnchecked = false;
      mod.map((row, key) => {
        const isAlreadyChecked = this.isAlreadyChecked(row[0]);
        if (
          !firstUnchecked &&
          !isAlreadyChecked &&
          !Number.isInteger(firstUnchecked)
        ) {
          if (key === 0) {
            firstUnchecked = -1;
          } else {
            firstUnchecked = key;
          }
        }
        if (
          !Number.isInteger(firstUnchecked) &&
          !firstUnchecked &&
          mod.length - 1 === key
        ) {
          firstUnchecked = 99;
        }
        Object.assign(row[1], {
          isAlreadyChecked: isAlreadyChecked ? true : false,
          firstUnchecked: firstUnchecked,
        });
        return row;
      });

      return mod != null ? Object.fromEntries(mod) : {};
    },
    adds() {
      let add;
      if (this.program === 'skp' && this.isLimitedVersion) {
        // add = ['K'].reduce((obj, key) => ({ ...obj, [key]: adds[key] }), {});
        add = null;
      } else if (this.program === 'skp' && this.isAccountant) {
        if (this.exchangeAdded) {
          add = a_skp_B.reduce(
            (obj, key) => ({ ...obj, [key]: adds[key] }),
            {}
          );
        } else {
          let addsModif = a_skp_B.filter((item) => item !== 'O');

          add = addsModif.reduce(
            (obj, key) => ({ ...obj, [key]: adds[key] }),
            {}
          );
        }
      } else if (this.skpAccountantAdd) {
        if (this.exchangeAdded) {
          add = a_skp_B.reduce(
            (obj, key) => ({ ...obj, [key]: adds[key] }),
            {}
          );
        } else {
          let addsModif = a_skp_B.filter((item) => item !== 'O');

          add = addsModif.reduce(
            (obj, key) => ({ ...obj, [key]: adds[key] }),
            {}
          );
        }
        add = addsModif.reduce(
          (obj, key) => ({ ...obj, [key]: adds[key] }),
          {}
        );
      } else if (
        (this.program === 'skp' && !this.isAccountant) ||
        this.skpCompanyAdd
      ) {
        let addsModif = a_skp_F.filter((item) => item !== 'A');

        add = addsModif.reduce(
          (obj, key) => ({ ...obj, [key]: adds[key] }),
          {}
        );
      } else {
        add = a_sam.reduce((obj, key) => ({ ...obj, [key]: adds[key] }), {});
      }

      add = add != null ? Object.entries(add) : [];
      add.sort((row) => (this.isAlreadyChecked(row[0]) ? -1 : 1));

      // sort product list to display it in two separate category when not-accountant checked "B"
      let firstUnchecked = false;
      add.map((row, key) => {
        const isAlreadyChecked = this.isAlreadyChecked(row[0]);
        if (
          !firstUnchecked &&
          !isAlreadyChecked &&
          !Number.isInteger(firstUnchecked)
        ) {
          if (key === 0) {
            firstUnchecked = -1;
          } else {
            firstUnchecked = key;
          }
        }
        if (
          !Number.isInteger(firstUnchecked) &&
          !firstUnchecked &&
          add.length - 1 === key
        ) {
          firstUnchecked = 99;
        }
        Object.assign(row[1], {
          isAlreadyChecked: isAlreadyChecked ? true : false,
          firstUnchecked: firstUnchecked,
        });
        return row;
      });
      return add != null ? Object.fromEntries(add) : {};
    },
    validateSource() {
      return this.validated && this.staffName && !this.orderSource
        ? false
        : null;
    },
    exchangeAdded() {
      return (
        (this.client.DOD !== null &&
          this.client.DOD !== '' &&
          this.client.DOD.split('').includes('X')) ||
        this.cartProducts.filter((item) => item.key === 'X').length !== 0
      );
    },
    osVersionsLink() {
      return this.program === 'skp'
        ? 'https://www.ksiega-podatkowa.pl/akademia-skp/wersja-glowna-podwersje-programu/'
        : 'https://www.samozatrudnienie.pl/przewodnik-przedsiebiorcy/wersja-glowna-podwersje-programu';
    },
    osLink() {
      return this.program === 'skp'
        ? 'https://www.ksiega-podatkowa.pl/opieka-serwisowa-skp/'
        : 'https://www.samozatrudnienie.pl/przewodnik-przedsiebiorcy/opieka-serwisowa-definicja';
    },
    startOfYear() {
      return (
        moment().format('YYYY-MM-DD') >= this.year + '-01-01' &&
        moment().format('YYYY-MM-DD') <= this.year + '-04-30'
      );
    },
    declarationsSeason() {
      return (
        moment().format('YYYY-MM-DD') >= this.year + '-01-01' &&
        moment().format('YYYY-MM-DD') <= this.year + '-06-30'
      );
    },
    discountsToCheckConditions() {
      let that = this;
      let program = this.program === 'skp' || this.skpAdd ? 'skp' : 'sam';
      let version = this.isAccountant || this.skpAccountantAdd ? 'B' : 'F';

      return Object.values(this.currentDiscounts).filter(function (item) {
        if (item.osBefore && that.currentOsOrder) {
          // adapted to VAT OSS discount
          return (
            moment(that.currentOsOrder.DATA) < moment(item.osBefore) &&
            that.currentOs &&
            that.client &&
            !that.client.MDS.split('').includes('L')
          );
        } else if (item.id === 610) {
          return true;
        } else {
          return (
            (item.program && item.program === program) ||
            (item.for && item.for === 'os' && that.currentOs) ||
            (item.for && item.for !== 'os' && item.for === version)
          );
        }
      });
    },
    discountsDescriptions() {
      let description = '';
      let that = this;
      Object.entries(
        this.discountsToCheckConditions != null
          ? this.discountsToCheckConditions
          : []
      ).forEach(([key, item]) => {
        if (item.id === 602) {
          description += !this.client.DOD.split('').includes('X')
            ? item.description
            : '';
        } else {
          description += item.description;
        }
      });

      return description;
    },
    unpaidOrderUrl() {
      let hasCurrentOs = this.currentOs ? 1 : 0;
      return (
        '/api/getLastUnpaidOrder/' +
        this.program +
        '/' +
        this.licence +
        '/' +
        hasCurrentOs
      );
    },
    validateEmailAndPhone() {
      let validated = [];

      if (!this.client.E1 || this.client.E1 === '') {
        validated.push('uzupełnij e-mail');
      }

      if (!this.client.TEL1 || this.client.TEL1 === '') {
        validated.push('uzupełnij telefon');
      }

      return validated;
    },
  },
  created() {
    this.getCloudDataByClient();
    this.getLastNotPaidOrder();
    this.getCurrentOsOrder();
    this.hasTwoLastYearsOsOrders();
    this.getOsPrice();
    this.getProductsPrices();
    this.getChangeToSkpProducts();
    this.getCurrentDiscounts();
    this.$store.commit('order/setOrderBy', this.staffName);
  },
  methods: {
    reloadProducts() {
      this.getOsPrice();
      this.getProductsPrices();
      this.getCurrentDiscounts();
      this.$store.commit('order/emptyCartProducts');
    },
    betweenDate(start, end) {
      return (
        moment().format('YYYY-MM-DD') >= start &&
        moment().format('YYYY-MM-DD') <= end
      );
    },
    formatSimpleWithDots(value) {
      return DateHelper.formatSimpleWithDots(value);
    },
    getCloudDataByClient() {
      axios
        .get('/api/getCloudDataByClient/' + this.program + '/' + this.licence)
        .then(({ data }) => {
          this.loading = false;

          let that = this;
          if (data.length > 0) {
            let plan = null;
            let months = [];
            data.forEach(function (item, index) {
              if (item.year == that.year) {
                if (that.program === 'skp') {
                  plan = skp_plans[item.plan_limit];
                }
                if (that.program === 'sam') {
                  plan = sam_plans[item.plan_limit];
                }
                months.push(item.month);
              }
            });
            this.$store.commit('order/setCurrentCloudPlan', plan);
            this.$store.commit('order/setCurrentCloudMonths', months);
            this.$emit('clouddatabyclient', plan);
            this.$emit('cloudNeverHave', false);
          } else {
            this.$emit('clouddatabyclient', null);
            this.$emit('cloudNeverHave', true);
          }
        });
    },
    getProductsPrices() {
      this.loading = true;
      axios
        .get('/api/productsPrices/' + this.program + '/' + this.licence)
        .then(({ data }) => {
          this.loading = false;

          this.productsPrices = data;
          this.aktu = data.filter((item) => item.ID === 28)[0];

          if (this.orderQuery !== null) {
            this.addProduct(this.getProductData({ key: this.orderQuery }));
          }
          this.accountantVersions = data.filter((item) =>
            item.label.includes('SKP® BIURO START')
          );
          this.paymentZUSVersionsF = data.filter(
            (item) =>
              item.label.includes('Płace i ZUS') &&
              item.UWAGI === 'M_SKP_MODULY_FIRMA'
          );
          this.paymentZUSVersionsB = data.filter(
            (item) =>
              item.label.includes('Płace i ZUS') &&
              item.UWAGI === 'M_SKP_MODULY_BIURO'
          );
        })
        .catch((error) => {});
    },
    backStep() {
      this.$store.commit('order/decrementStep');
    },
    forwardStep() {
      this.errors = [];
      this.validated = false;
      this.validateForm();
      if (this.staffName) {
        this.validateStaffData();
      }

      if (this.staffName && this.validateEmailAndPhone.length > 0) {
        let msg =
          'Przejdź do zakładki Dane licencyjne i uzupełnij telefon i e-mail. Pola te są obowiązkowe. Bez podanego e-maila i telefonu nie da się złożyć zamówienia.';
        this.$bvModal
          .msgBoxConfirm(msg, {
            title: '',
            size: 'sm',
            buttonSize: 'sm',
            okVariant: 'success',
            okTitle: 'Uzupełnij dane',
            cancelTitle: 'Wróć',
            footerClass: 'p-2',
            hideHeaderClose: false,
            centered: true,
          })
          .then((value) => {
            if (value) {
              this.$router.push({ name: 'Licence' });
            }
          });
      } else if (this.discountsToCheckConditions.length > 0) {
        this.checkDiscountsConditions();

        if (this.discountErrorMsg !== '') {
          this.$bvModal
            .msgBoxConfirm(this.discountErrorMsg, {
              title: '',
              size: 'sm',
              buttonSize: 'sm',
              okVariant: 'success',
              okTitle: 'Tak',
              cancelTitle: 'Rezygnuję z promocji',
              footerClass: 'p-2',
              hideHeaderClose: false,
              centered: true,
            })
            .then((value) => {
              if (!value) {
                this.seasonalDiscountUsed = null;
                this.$store.commit(
                  'order/setSeasonalDiscount',
                  this.seasonalDiscountUsed
                );
                this.calculatePricesWithDiscount();
                this.proceedForward();
              }
            });
        } else {
          this.seasonalDiscountUsed = this.checkIfSeasonalDiscountUsed();
          this.$store.commit(
            'order/setSeasonalDiscount',
            this.seasonalDiscountUsed
          );
          this.calculatePricesWithDiscount();
          this.proceedForward();
        }
      } else {
        this.proceedForward();
      }
    },
    proceedForward() {
      if (this.errors.length === 0) {
        this.$store.commit('order/incrementStep');
        this.$store.commit('order/setOs', !this.currentOs);
      }
    },
    getCurrentOsOrder() {
      axios
        .get('/api/currentOsOrder/' + this.program + '/' + this.licence)
        .then(({ data }) => {
          this.currentOsOrder = data;
        });
    },
    hasTwoLastYearsOsOrders() {
      axios
        .get(
          '/api/hasTwoLastYearsOsOrders/' + this.program + '/' + this.licence
        )
        .then(({ data }) => {
          this.twoLastYearsOsOrders = data;
        });
    },
    getOsPrice() {
      this.loading = true;
      axios
        .get('/api/getOsPrice/' + this.program + '/' + this.licence)
        .then(({ data }) => {
          this.loading = false;
          this.osOldPrice = data.osOldPrice;
          this.osPrice = data.osPrice;
          this.osDiscount = data.discount;
          if (!this.currentOs) {
            this.$store.commit('order/setOsOldPrice', this.osOldPrice);
            this.$store.commit('order/setOsPrice', this.osPrice);
            if (data.discount !== null) {
              this.$store.commit('order/addDiscount', data.discount);
            }
          }
        });
    },
    getUnpaidOrderPayu(id) {
      let type = this.currentOs ? 'zam' : 'aktu';
      axios
        .get('/api/orderWithPayu/' + this.program + '/' + id + '/' + type)
        .then(({ data }) => {
          this.unpaidOrderPayu = data;
        });
    },
    getChangeToSkpProducts() {
      axios
        .get('/api/getChangeToSkpProducts/' + this.program)
        .then(({ data }) => {
          this.changeToSkpProducts = data;
        });
    },
    getCurrentDiscounts() {
      this.loading = true;
      axios.get('/api/currentDiscounts/' + this.program).then(({ data }) => {
        if (data) {
          this.loading = false;
          this.currentDiscounts = data;
          let that = this;
          Object.values(data).forEach(function (item) {
            that.$store.commit('order/addDiscount', item);
          });
        }
      });
    },
    getLastNotPaidOrder() {
      this.loading = true;
      axios.get(this.unpaidOrderUrl).then(({ data }) => {
        if (data.order && !data.order.deleted_at) {
          this.unpaidOrderData = data;
          this.loading = false;
          if (this.unpaidOrderData.order) {
            this.unpaidOrder = this.unpaidOrderData.order;
            this.getUnpaidOrderPayu(this.unpaidOrderData.order.Id);
          }
        }
      });
    },
    confirmRemove() {
      this.$bvModal
        .msgBoxConfirm('Czy na pewno chcesz usunąć zamówienie?', {
          title: '',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'success',
          okTitle: 'Usuń',
          cancelTitle: 'Anuluj',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          this.boxOne = value;
          if (value) {
            this.removeOrder();
          }
        });
    },
    removeOrder() {
      let data = {
        order: this.unpaidOrderData.order,
        program: this.program,
      };
      axios.post('/api/removeOrder', data).then((response) => {
        this.unpaidOrderData = false;
      });
    },
    validateForm() {
      this.validated = true;
      if (!this.currentOs && this.os !== true && !this.formsoftStaff) {
        this.errors.push('Wybierz Opiekę Serwisową.');
      } else {
        this.errors = [];
      }
    },
    validateStaffData() {
      if (this.staffName && !this.orderSource) {
        this.errors.push('Wybierz formę zamówienia.');
        this.validated = true;
      }
    },
    getProductData(product) {
      let program = this.program === 'skp' || this.skpAdd ? 'skp' : 'sam';
      let version = this.isAccountant || this.skpAccountantAdd ? 'B' : 'F';
      let that = this;

      return this.productsPrices.filter(function (item) {
        if (program === 'skp') {
          return (
            item.key == (typeof product !== 'undefined' ? product.key : '') &&
            item.versions.includes(version)
          );
        } else {
          return (
            item.key == (typeof product !== 'undefined' ? product.key : '') &&
            item.program.includes('sam')
          );
        }
      })[0];
    },
    commaFormat(value) {
      return Number(value).toLocaleString('fr-FR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    minimAddChanged(value) {
      this.minimAdd = value;
      let invoiceModuleAdded =
        this.cartProducts.find((row) => row.key === 'M') !== undefined;

      if (value && invoiceModuleAdded) {
        this.$store.commit('order/removeProduct', { ID: 56 });
      }
    },
    showProductsElements(value) {
      if (this.program === 'sam') {
        this.moduleElementShow = false;
      } else if (!this.moduleElementShow && value === 'module') {
        this.moduleElementShow = true;
      } else if (!this.addElementShow && value === 'add') {
        this.addElementShow = true;
      }
    },
    addProduct(product) {
      if (!(product.key === 'deklaracje' && this.annualDeclAlreadyChecked)) {
        if (this.isInCart(product)) {
          this.$store.commit('order/removeProduct', product);

          let checkLimitedVersionsInCart = this.cartProducts.filter((item) => {
            return item.key === 'O';
          });

          if (product.key === 'X' && checkLimitedVersionsInCart.length !== 0) {
            this.$store.commit(
              'order/removeProduct',
              checkLimitedVersionsInCart[0]
            );
          }
          if (this.isTransferFromSamToSkp(product)) {
            if (!this.currentOs) {
              this.$store.commit('order/setOsOldPrice', this.osOldPrice);
              this.$store.commit('order/setOsPrice', this.osPrice);
              if (this.osDiscount) {
                this.$store.commit('order/setDiscount', this.osDiscount.name);
              }
            }

            this.accountantAddChanged(null);
            this.paymentZusProductChanged(null);
          }

          if (['P1', 'P2', 'P3'].includes(product.key)) {
            this.paymentZusProductChanged(null);
          }

          if (['B1', 'B2', 'B3'].includes(product.key)) {
            this.accountantAddChanged(null);
          }

          if (
            (this.program === 'skp' && !this.isAccountant) ||
            this.skpCompanyAdd
          ) {
            if (product.key === 'F') {
              let m = this.getProductByKey('M');
              if (this.isInCart(m)) {
                this.$store.commit('order/removeProduct', m);
              }
            }

            if (product.key === 'M') {
              let f = this.getProductByKey('F');
              if (this.isInCart(f)) {
                this.$store.commit('order/removeProduct', f);
              }
            }
          }
        } else {
          let that = this;
          if (this.isTransferFromSamToSkp(product)) {
            if (
              (this.skpCompanyAdd &&
                ['B1', 'B2', 'B3'].includes(product.key)) ||
              (this.skpAccountantAdd &&
                !['B1', 'B2', 'B3'].includes(product.key))
            ) {
              this.cartProducts.filter(function (item) {
                if (item.ID !== product.ID) {
                  that.$store.commit('order/removeProduct', item);
                }
              });
            }

            this.$store.commit('order/setOsOldPrice', null);
            this.$store.commit('order/setOsPrice', null);
            this.$store.commit('order/setDiscount', null);
          }

          if (['P1', 'P2', 'P3'].includes(product.key)) {
            this.paymentZusProductChanged(product);
          } else if (
            ['B1', 'B2', 'B3'].includes(product.key) ||
            this.isTransferFromSamToSkp(product)
          ) {
            that.accountantAddChanged(product);
          } else {
            this.$store.commit('order/addProduct', product);
          }

          if (
            product.key === 'M' &&
            ((this.program === 'skp' &&
              !this.isAccountant &&
              !this.client.MDS.split('').includes('F')) ||
              this.skpCompanyAdd)
          ) {
            let f = this.getProductByKey('F');

            if (!this.isInCart(f)) {
              this.$store.commit('order/addProduct', f);
            }
          }
        }
        // this.$forceUpdate();
        this.$emit('addedproduct');
      }
    },
    getProductByKey(key) {
      return this.getProductData(
        Object.values(this.modules).find((e) => {
          return e.key === key;
        })
      );
    },
    accountantAddChanged(value) {
      let that = this;

      this.cartProducts.filter(function (item) {
        if (item.label.includes('SKP® BIURO START')) {
          that.$store.commit('order/removeProduct', item);
        }
      });

      if (!this.isAccountant || (this.isAccountant && !value)) {
        a_all.forEach(function (item) {
          that.$store.commit('order/removeProductByKey', item);
        });

        m_all.forEach(function (item) {
          that.$store.commit('order/removeProductByKey', item);
        });

        if (this.program === 'sam') {
          this.$store.commit('order/removeProductByKey', 'deklaracje');
        }
      }

      if (value && value.NETTO >= 0) {
        this.$store.commit('order/addProduct', value);
      }

      this.$emit('addedproduct');

      if (
        this.program === 'skp' &&
        this.cartProducts.filter(
          (row) => row.key === 'B1' || row.key === 'B2' || row.key === 'B3'
        ).length > 0 &&
        !this.client.MDS.split('').includes('B')
      ) {
        this.addAlreadyExistingModules(
          m_skp_B.reduce((obj, key) => ({ ...obj, [key]: modules[key] }), {})
        );
        this.addAlreadyExistingAdds(
          a_skp_B.reduce((obj, key) => ({ ...obj, [key]: adds[key] }), {})
        );
      }
    },
    paymentZusProductChanged(value) {
      let that = this;

      this.cartProducts.filter(function (item) {
        if (item.label.includes('Płace i ZUS')) {
          that.$store.commit('order/removeProduct', item);
        }
      });

      if (value && value.NETTO >= 0) {
        this.$store.commit('order/addProduct', value);
      }
    },
    checkDiscountsConditions() {
      this.discountErrorMsg = '';
      this.discountNotUsed = null;
      let that = this;
      this.discountsToCheckConditions.forEach(function (discount, key) {
        if (discount.errorMsg && discount.conditions) {
          discount.conditions.forEach(function (condition) {
            if (
              that.cartProducts.filter((item) => item.ID === condition)
                .length === 0
            ) {
              that.discountNotUsed = discount.id;
              if (discount.id === 602) {
                that.discountErrorMsg = discount.errorMsg;
              }
            }
          });
        }
      });
    },
    calculatePricesWithDiscount() {
      let that = this;

      this.discountsToCheckConditions.forEach(function (discount, key) {
        Object.keys(discount.products).forEach(function (productId) {
          if (
            that.cartProducts.filter((item) => item.ID == productId).length > 0
          ) {
            let product = that.cartProducts.filter(
              (item) => item.ID == productId
            )[0];

            that.$store.commit('order/removeProduct', product);
            if (that.discountNotUsed && discount.id === that.discountNotUsed) {
              product.NETTO = product.OLD_NETTO
                ? product.OLD_NETTO
                : product.NETTO;
              product.BRUTTO = product.OLD_BRUTTO
                ? product.OLD_BRUTTO
                : product.BRUTTO;
              that.$store.commit('order/addProduct', product);
            } else {
              let productOriginal = that.getProductData(product);
              that.$store.commit('order/addProduct', productOriginal);
            }
          }
        });
        // }
      });
    },
    proceedToNewOrder() {
      this.unpaidOrderData = null;
      this.unpaidOrderPayu = null;
    },
    checkIfSeasonalDiscountUsed() {
      let vatOss = this.cartProducts.find((e) => {
        return e.label === 'VAT OSS';
      });
      if (this.discountsToCheckConditions[0].id === 604 && vatOss) {
        return 604;
      }
      let course = this.cartProducts.find((e) => {
        return e.ID === 97;
      });
      if (this.discountsToCheckConditions[0].id === 610 && course) {
        return 610;
      }
      return null;
    },
    isTransferFromSamToSkp(item) {
      return (
        (item.UWAGI === 'N_SKP' && item.key !== 'O') ||
        (this.program === 'sam' &&
          (item.key === 'B1' || item.key === 'B2' || item.key === 'B3'))
      );
    },
    addAlreadyExistingModules(modules) {
      let that = this;
      Object.values(modules).forEach(function (md) {
        if (that.client.MDS.split('').includes(md.key)) {
          let product = that.productsPrices.filter(
            (item) => item.key === md.key && item.versions.includes('B')
          )[0];

          if (!that.isInCart(product)) {
            that.$store.commit('order/addProduct', product);
          }
        }
      });

      if (this.client.MDS.split('').includes('P')) {
        let version = this.client.P_level;
        let p = this.paymentZUSVersionsB.find(
          (item) => item.key === 'P' + version
        );

        if (!this.isInCart(p)) {
          this.$store.commit('order/addProduct', p);
        }
      }
    },
    addAlreadyExistingAdds(adds) {
      let that = this;
      Object.values(adds).forEach(function (add) {
        if (that.client.DOD.split('').includes(add.key)) {
          let product = that.productsPrices.filter(
            (item) => item.key === add.key && item.versions.includes('B')
          )[0];

          if (!that.isInCart(product)) {
            that.$store.commit('order/addProduct', product);
          }
        }
      });
    },
    warningOsMandatory() {
      this.$bvModal.msgBoxOk(
        'Usługa podstawowa umożliwiająca dokonanie zakupu innych produktów i usług (opcja niemożliwa do odznaczenia).',
        {
          title: '',
          size: 'sm',
          buttonSize: 'sm',
          footerClass: 'p-2',
          hideHeaderClose: false,
        }
      );
    },
    isAlreadyChecked(productKey) {
      if (
        productKey === 'F' &&
        !this.isAccountant &&
        this.client.MDS !== null &&
        this.client.MDS !== '' &&
        this.client.MDS.split('').includes('M')
      ) {
        return true;
      }

      return this.clientOwns(productKey);
    },
    clientOwns(productKey) {
      return (
        (this.client.MDS !== null &&
          this.client.MDS !== '' &&
          this.client.MDS.split('').includes(productKey) &&
          !this.skpAdd) ||
        (this.client.DOD !== null &&
          this.client.DOD !== '' &&
          this.client.DOD.split('').includes(productKey))
      );
    },
    runChat() {
      document.getElementById('chatbase-bubble-button').click();
    },
  },
};
</script>
